import { DietaryType } from "./DietaryDisplayList";

type ProductDietaryOptions = {
  vegan: boolean | null | undefined;
  lactoseFree: boolean | null | undefined;
  glutenFree: boolean | null | undefined;
};

type BuildDietaryListParameters = {
  childProduct: ProductDietaryOptions;
  parentProduct?: ProductDietaryOptions;
};

export const buildDietaryList = ({
  childProduct,
  parentProduct,
}: BuildDietaryListParameters) => {
  const dietaryList: DietaryType[] = [];

  if (
    childProduct.vegan ||
    (childProduct.vegan !== false && parentProduct?.vegan)
  ) {
    dietaryList.push("VG");
  }

  if (
    childProduct.glutenFree ||
    (childProduct.glutenFree !== false && parentProduct?.glutenFree)
  ) {
    dietaryList.push("GF");
  }

  if (
    childProduct.lactoseFree ||
    (childProduct.lactoseFree !== false && parentProduct?.lactoseFree)
  ) {
    dietaryList.push("LF");
  }

  return dietaryList;
};
